import { Component } from "@angular/core";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";
import { TiposServicioDTO } from "src/app/models/tipo-servicio.dto";

@Component({
  selector: "app-form-tipos-servicios",
  templateUrl: "./form.component.html",
})
export class TiposServicioForm extends CrudForm<TiposServicioDTO> {
  public fromInit(row: TiposServicioDTO) {
    this.form.controls["IdTipoServicio"].setValue(row?.IdTipoServicio);
    this.form.controls["Descripcion"].patchValue(row?.Descripcion);
  }

  protected buildForm() {
    this.form = this.fb.group({
      IdTipoServicio: [""],
      Descripcion: [""],
    });
  }
}
